import { Typography } from "@suraasa/placebo-ui"
import clsx from "clsx"

type Props = {
  title: string
  count?: number
  color: string
}

const OverviewStatCard = ({ title, count, color }: Props) => {
  return (
    <div className="flex w-full flex-col justify-between rounded-lg border px-2 pb-1 pt-2 shadow-sm">
      <div>
        <Typography variant="body" className="text-onSurface-500">
          {title}
        </Typography>
      </div>
      <div>
        <div className="flex w-full flex-row items-center justify-between">
          {count === undefined ? (
            <div className="h-1.5 w-8 animate-pulse rounded-md bg-onSurface-300 duration-700" />
          ) : (
            <Typography variant="title2">{count}</Typography>
          )}
          <div
            // eslint-disable-next-line tailwindcss/migration-from-tailwind-2
            className={clsx(
              "m-1 flex items-center justify-center rounded-full bg-opacity-15 p-1",
              color
            )}
          >
            <div className={clsx("size-1.75 rounded-full", color)} />
          </div>
        </div>
      </div>
    </div>
  )
}
export default OverviewStatCard
